export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
          安全访问入口
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10 max-w-lg mx-auto">
          通过以下安全方式访问暗网指南与深度网资源，保护你的隐私安全
        </p>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 border border-background-200/60 rounded-lg p-6 md:p-8 flex flex-col sm:flex-row items-center gap-6">
            <div className="w-16 h-16 rounded-full bg-primary-500/10 border border-primary-500/20 flex items-center justify-center shrink-0">
              <i className="ri-smartphone-line text-2xl text-primary-400"></i>
            </div>
            <div className="flex-1 text-center sm:text-left">
              <h3 className="font-heading text-lg font-semibold text-foreground-100 mb-2">
                暗网安全访问助手
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed mb-4">
                本站提供暗网安全访问完整指南，涵盖Tor浏览器下载配置、暗网网址导航、VPN搭配建议、匿名环境搭建等全方位教程。无论使用桌面端还是移动端，均可安全浏览暗网深度网内容。
              </p>
              <div className="flex flex-wrap gap-3 justify-center sm:justify-start">
                <a
                  href="#index"
                  className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-background-950 font-medium text-sm rounded-md transition-all duration-200 whitespace-nowrap"
                >
                  查看指南索引
                </a>
                <a
                  href="#faq"
                  className="px-5 py-2 bg-background-100 hover:bg-background-200 border border-background-300 text-foreground-300 hover:text-foreground-100 font-medium text-sm rounded-md transition-all duration-200 whitespace-nowrap"
                >
                  常见问答
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}